var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M135.23 58.906c5.972 0 11.687 2.852 15.265 7.632l15.741 20.99h78.71c10.523 0 19.08 8.567 19.08 19.08v95.405c0 10.523-8.557 19.081-19.08 19.081H92.297c-10.524 0-19.081-8.558-19.081-19.08v-41.66h19.08v41.66h152.658l-.01-95.406h-78.709c-5.972 0-11.687-2.852-15.264-7.632l-15.742-20.99H92.298v41.66H73.217v-41.66c0-10.513 8.557-19.08 19.08-19.08zM122.02 92.298l46.6 47.552-46.45 47.852-14.04-14.355 22.703-23.029H15.974v-20.487h114.411l-22.105-23.178z"
})));
export default SvgFolderIn;